import { useState } from 'react'
import PropTypes from 'prop-types'
import { useTheme } from '@material-ui/styles'

import { Box, TablePagination, useMediaQuery } from '@material-ui/core'

import { Page, Container, ContentHeader, BackButton, Card } from 'components'
import {
  RegulationForm,
  RegulationVersionsTable,
  VersionModal,
} from './components'

import { useFetch, usePagination } from 'hooks'

import * as service from 'service'
import constants from 'constants/index'

const RegulationsShow = ({ match }) => {
  const [openModal, setOpenModal] = useState(false)
  const [selectedVersion, setSelectedVersion] = useState(null)

  const { regulationId } = match.params

  const theme = useTheme()
  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'), {
    defaultMatches: true,
  })

  const { perPage, page, handleChangePage, handleChangeRowsPerPage } =
    usePagination(5)

  const { response, isLoading } = useFetch(
    service.backoffice.regulations.get,
    { regulationId },
    [regulationId],
  )

  const { response: versionsResponse, isLoading: isVersionsLoading } = useFetch(
    service.backoffice.regulationVersions.get,
    { regulationId, perPage, page },
    [regulationId, perPage, page],
  )

  const regulation = response?.data?.regulation
  const regulationVersions = versionsResponse?.data?.regulationVersions || []
  const totalVersionsCount = versionsResponse?.data?.meta?.totalCount || 0

  const handleOpenModal = (regulationVersionId) => {
    const regulationVersion = regulationVersions.find(
      (regulationVersion) => regulationVersion?.id === regulationVersionId,
    )

    setSelectedVersion(regulationVersion)
    setOpenModal(true)
  }

  return (
    <Page title="Visualizar regulamento">
      <Container
        maxWidth={false}
        spacingXl={30}
        spacingLg={25}
        spacingMd={10}
        spacingSm={10}
      >
        <ContentHeader
          title="Visualizar"
          menu="Documentos"
          subtitle="Visualizar regulamento"
        />
        <Box display="flex" flexDirection="column" gridGap={theme.spacing(4)}>
          <RegulationForm
            type={constants.regulations.FORM_TYPES.SHOW}
            regulation={regulation}
            isLoading={isLoading}
            key={isLoading ? 'show-regulation-loading' : 'show-regulation'}
          />
          <Card title="Versões" fromTable withPagination>
            <RegulationVersionsTable
              regulationVersions={regulationVersions}
              isLoading={isVersionsLoading}
              type={constants.regulations.FORM_TYPES.SHOW}
              onShow={handleOpenModal}
            />
            <Box px={2} display="flex" justifyContent="flex-end">
              <TablePagination
                component="div"
                count={totalVersionsCount}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                page={page - 1}
                rowsPerPage={perPage}
                rowsPerPageOptions={[5, 10, 25, 100]}
                labelRowsPerPage={isDesktop ? 'Por página' : ''}
                nextIconButtonProps={{ size: 'small' }}
                backIconButtonProps={{ size: 'small' }}
              />
            </Box>
          </Card>
          <VersionModal
            open={openModal}
            setOpen={setOpenModal}
            type={constants.regulations.FORM_TYPES.SHOW}
            regulationVersion={selectedVersion}
          />
          <Box>
            <BackButton />
          </Box>
        </Box>
      </Container>
    </Page>
  )
}

RegulationsShow.propTypes = {
  match: PropTypes.object,
}

export default RegulationsShow
